import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import '../../PropertyWalkThroughForm/ConfigurePropertyWalkThrough.scss';
import './HomeownerOnboardingComponent.scss';
import File from '../../File';
import Tabs from '../../Tabs';
import Select from '../../Select';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { fetchProperties } from '../../../store/actions/properties';
import { selectProperties } from '../../../store/selectors/properties';
import { selectHomeownerOnboardingFormData } from '../../../store/selectors/HomeownerOnboardingComponent';
import {
  setHomeownerOnboardingFormData,
  saveHomeOwnerOnboarding,
  changeOrdersSequence,
  clearsetHomeownerOnboardingFormData,
  fetchHomeOwnerOnboarding,
  clearHomeOwnerOnboarding,
  onUpdateSuiteOnBoardingFAQsOrder,
  onUpdateSuiteOnBoardingChecklistsOrder,
  onUpdateSuiteOnBoardingKeysOrder,
  onUpdateSuiteOnBoardingOffersOrder,
  onDeleteOrder,
} from '../../../store/actions/HomeownerOnboardingComponent';
import Row from '../../Row';
import Col from '../../Col';
import FontAwesomeIcon from '../../Icon';
import { AddFaqComponent } from './AddFaq';
import { AddChecklistComponent } from './AddChecklist';
import { AddKeyInformation } from './AddKeyInformation';
import { AddOffers } from './AddOffers';
import { selectHomeownerOnboarding } from '../../../store/selectors/HomeownerOnboarding';
import { upload } from '../../../helpers/upLoadHelper';
import { startFormLoading } from '../../../store/actions/loader';
import { selectFormLoader } from '../../../store/selectors/FormLoader';
import Loader from '../../Loader';
import { URLValidation } from '../../../helpers/validationHelper';
import TextEditor from '../../Editor/Editor';
import { Colors } from '../../../Tenants';
import OnboardingOrders from './OnboardingOrders';
import { selectPRLoader } from '../../../store/selectors/PropertyLoader';
import Checkbox from '../../Checkbox';
import { S3BucketConfig } from '../../../common/constants';

const validEmailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

class HomeownerOnboardingComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: '',
      videoSummary: '',
      summaryText: '',
      faqTitle: '',
      faqDescription: '',
      checklistTitle: '',
      checklistSubtitle: '',
      name: '',
      department: '',
      email: '',
      phone: '',
      selectedId: null,
      faqValidation: '',
      emailValidationMessage: '',
      checklistValidation: '',
      offerValidation: '',
      sequence: {},
      isEnableReorder: false,
      offerName: '',
      offerDescription: '',
      offerDescriptionEditor: '',
      checklistSubtitleEditor: '',
      offerLink: 'https://',
      offerLable: '',
      selectedOfferImage: [],
      sortingObject: {},
      isLegalRepresentativeInformation: 'no',
      loading: false,
      occupancyRole: '',
    };
  }
  componentDidMount() {
    const {
      onFetchProperties,
      user,
      onClearHomeownerOnboardingFormData,
      clearHomeOwnerOnboarding,
    } = this.props;
    onClearHomeownerOnboardingFormData();
    clearHomeOwnerOnboarding();
    onFetchProperties(user.id, user.roles[0].role.name);
  }

  fetchOrderData(order) {
    if (!this.state.isEnableReorder) {
      this.setState({
        faqTitle: '',
        faqDescription: '',
        checklistTitle: '',
        checklistSubtitle: '',
        name: '',
        department: '',
        email: '',
        phone: '',
        faqValidation: '',
        emailValidationMessage: '',
        checklistValidation: '',
        offerValidation: '',
        isEnableReorder: false,
        offerName: '',
        offerDescription: '',
        offerDescriptionEditor: '',
        checklistSubtitleEditor: '',
        offerLink: 'https://',
        offerLable: '',
        selectedOfferImage: [],
        isLegalRepresentativeInformation: 'no',
        occupancyRole: '',
      });
      this.setState({
        isLegalRepresentativeInformation:
          order.isLegalRepresentativeInformation == true ? 'yes' : 'no',
      });
      if (order.isPostOccupancy === true) {
        this.setState({ occupancyRole: 'PostOccupancy' });
      } else {
        this.setState({ occupancyRole: 'PreOccupancy' });
      }
      let editorState = order.summary ? order.summary : '';
      let videoSummary = order.videoSummary ? order.videoSummary : '';
      let summaryText;
      summaryText = order.summary.replace(/<[^>]+>/g, '');

      this.setState({
        editorState: editorState,
        summaryText: summaryText,
        videoSummary: videoSummary,
      });
      if (order.videoType === 'URL' && order.video) {
        this.props.onSetHomeownerOnboardingFormData({
          attachment: [order.video],
        });
      } else {
        this.props.onSetHomeownerOnboardingFormData({
          attachment: [],
        });
      }
      let offers;
      let checklists;
      if (
        order &&
        order.suiteOnBoardingChecklist &&
        order.suiteOnBoardingChecklist.length > 0
      ) {
        checklists = order.suiteOnBoardingChecklist;
      }
      if (
        order &&
        order.suiteOnBoardingOffers &&
        order.suiteOnBoardingOffers.length > 0
      ) {
        offers = order.suiteOnBoardingOffers.map((offer) => {
          return {
            ...offer,
            description: offer.description,
            descriptionEditor: offer.description,
            image: offer.logo ? offer.logo : '',
            logo: [offer.logo],
          };
        });
      }
      setTimeout(() => {
        this.props.onSetHomeownerOnboardingFormData({
          id: order.id,
          suiteOnBoardingTitle: this.props.homeownerOnboardingFormData
            .suiteOnBoardingTitle
            ? this.props.homeownerOnboardingFormData.suiteOnBoardingTitle
            : order.suiteOnBoardingTitle
              ? order.suiteOnBoardingTitle
              : '',
          propertyId: order.propertyId,
          title: order.title,
          videoType: order.videoType,
          videoLink: order.videoType === 'Link' ? order.video : '',
          summary: order.summary,
          videoSummary: order.videoSummary,
          faqs: order.suiteOnBoardingFAQs,
          checklists: checklists,
          keys: order.suiteOnboardingKeyInformation,
          offers: offers,
          isLegalRepresentativeInformation:
            this.state.isLegalRepresentativeInformation,
        });
        this.setState({ loading: false });
      }, 10);
    }
  }

  clearStateData = () => {
    this.setState({
      faqTitle: '',
      faqDescription: '',
      checklistTitle: '',
      checklistSubtitle: '',
      name: '',
      department: '',
      email: '',
      phone: '',
      selectedId: null,
      faqValidation: '',
      emailValidationMessage: '',
      checklistValidation: '',
      sequence: {},
      summaryText: '',
      editorState: '',
      videoSummary: '',
      offerValidation: '',
      offerName: '',
      offerDescription: '',
      offerDescriptionEditor: '',
      checklistSubtitleEditor: '',
      offerLink: 'https://',
      offerLable: '',
      selectedOfferImage: [],
      isLegalRepresentativeInformation: 'no',
      occupancyRole: '',
    });
  };

  onClearData = async () => {
    const {
      homeownerOnboardingFormData,
      onClearHomeownerOnboardingFormData,
      onSetHomeownerOnboardingFormData,
      onFetchHomeOwnerOnboarding,
    } = this.props;
    let propertyId = homeownerOnboardingFormData.propertyId;
    await onClearHomeownerOnboardingFormData();
    if (propertyId) {
      onSetHomeownerOnboardingFormData({ propertyId: propertyId });
      onFetchHomeOwnerOnboarding(propertyId);
    }
    this.clearStateData();
  };

  onReorder = () => {
    this.setState({ isEnableReorder: !this.state.isEnableReorder });
    this.onClearData();
  };

  selectMultipleItems = (files) => {
    const { onSetHomeownerOnboardingFormData } = this.props;
    onSetHomeownerOnboardingFormData({
      attachment: files,
      videoType: 'URL',
      isupload: true,
    });
  };

  handleDelete(item, i) {
    const { onSetHomeownerOnboardingFormData } = this.props;
    onSetHomeownerOnboardingFormData({ attachment: [] });
  }

  onEditorChange1 = (editorState) => {
    const { onSetHomeownerOnboardingFormData } = this.props;

    this.setState(
      {
        videoSummary: editorState,
      },
      () => {
        onSetHomeownerOnboardingFormData({
          videoSummary: editorState,
        });
      }
    );
  };

  onSetFaq = (value, type) => {
    this.setState({ [type]: value, faqValidation: '' });
  };

  onSetchecklist = (value, type) => {
    this.setState({
      [type]: value,
      emailValidationMessage: '',
      checklistValidation: '',
      offerValidation: '',
    });
  };

  onEditorOfferChange = (editorState) => {
    this.setState({
      offerDescription: editorState,
      offerDescriptionEditor: editorState,
    });
  };

  onEditorFaqChange = (editorState) => {
    this.setState({
      checklistSubtitle: editorState,
      checklistSubtitleEditor: editorState,
    });
  };

  onSetEditFaq = (value, type, index) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData = homeownerOnboardingFormData.faqs.map((fq, i) => {
      if (i === index) {
        return { ...fq, [type]: value };
      } else {
        return fq;
      }
    });
    onSetHomeownerOnboardingFormData({ faqs: filterData });
  };

  onSetEditchecklists = (value, type, index) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData = homeownerOnboardingFormData.checklists.map((cl, i) => {
      if (i === index) {
        if (type === 'subTitle') {
          // const contentState = value.getCurrentContent();
          return { ...cl, [type]: value, subTitleEditor: value };
        } else {
          return { ...cl, [type]: value };
        }
      } else {
        return cl;
      }
    });

    onSetHomeownerOnboardingFormData({ checklists: filterData });
  };

  onSetEditkeys = (value, type, index) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData = homeownerOnboardingFormData.keys.map((cl, i) => {
      if (i === index) {
        return { ...cl, [type]: value };
      } else {
        return cl;
      }
    });
    onSetHomeownerOnboardingFormData({ keys: filterData });
  };

  onAddFaq = () => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let params = {
      name: this.state.faqTitle.trim(),
      description: this.state.faqDescription.trim(),
    };
    if (
      homeownerOnboardingFormData &&
      homeownerOnboardingFormData.faqs &&
      homeownerOnboardingFormData.faqs.length > 0
    ) {
      let validation = homeownerOnboardingFormData.faqs.filter(
        (key) =>
          key.name.toLowerCase() === this.state.faqTitle.toLowerCase().trim()
      );
      if (validation && validation.length === 0) {
        onSetHomeownerOnboardingFormData({
          faqs: [...homeownerOnboardingFormData.faqs, params],
        });
        this.setState({ faqTitle: '', faqDescription: '', faqValidation: '' });
      } else {
        this.setState({
          faqValidation:
            'You have already created faq with this question, please use different one.',
        });
      }
    } else {
      onSetHomeownerOnboardingFormData({ faqs: [params] });
      this.setState({ faqTitle: '', faqDescription: '', faqValidation: '' });
    }
  };

  handleFaqDelete = (data, index) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.faqs.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.faqs.filter((fq) => fq !== data);
    }
    onSetHomeownerOnboardingFormData({ faqs: filterData });
  };

  onSortingFAQ = async (data, index, type) => {
    const {
      homeownerOnboardingFormData,
      onUpdateSuiteOnBoardingFAQsOrder,
      onSetHomeownerOnboardingFormData,
    } = this.props;
    if (type === 'start') {
      this.setState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        this.state.sortingObject &&
        this.state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: this.state.sortingObject.id, order: data.order },
            { id: data.id, order: this.state.sortingObject.order },
          ],
          UserId: this.props.user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await onUpdateSuiteOnBoardingFAQsOrder(
          params,
          homeownerOnboardingFormData.faqs
        );
        this.setState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.faqs.map((faq) => {
          if (faq === data) {
            return this.state.sortingObject;
          } else if (faq === this.state.sortingObject) {
            return data;
          } else {
            return faq;
          }
        });
        await onSetHomeownerOnboardingFormData({ faqs: sortingData });
        this.setState({ sortingObject: {} });
      }
    }
  };

  onSortingChecklist = async (data, index, type) => {
    const {
      homeownerOnboardingFormData,
      onUpdateSuiteOnBoardingChecklistsOrder,
      onSetHomeownerOnboardingFormData,
    } = this.props;
    if (type === 'start') {
      this.setState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        this.state.sortingObject &&
        this.state.sortingObject.id !== data.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: this.state.sortingObject.id, order: data.order },
            { id: data.id, order: this.state.sortingObject.order },
          ],
          UserId: this.props.user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await onUpdateSuiteOnBoardingChecklistsOrder(
          params,
          homeownerOnboardingFormData.checklists
        );
        this.setState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.checklists.map(
          (checklist) => {
            if (checklist === data) {
              return this.state.sortingObject;
            } else if (checklist === this.state.sortingObject) {
              return data;
            } else {
              return checklist;
            }
          }
        );
        await onSetHomeownerOnboardingFormData({ checklists: sortingData });
        this.setState({ sortingObject: {} });
      }
    }
  };

  onSortingKey = async (data, index, type) => {
    const {
      homeownerOnboardingFormData,
      onUpdateSuiteOnBoardingKeysOrder,
      onSetHomeownerOnboardingFormData,
    } = this.props;
    if (type === 'start') {
      this.setState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        this.state.sortingObject &&
        this.state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: this.state.sortingObject.id, order: data.order },
            { id: data.id, order: this.state.sortingObject.order },
          ],
          UserId: this.props.user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await onUpdateSuiteOnBoardingKeysOrder(
          params,
          homeownerOnboardingFormData.keys
        );
        this.setState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.keys.map((key) => {
          if (key === data) {
            return this.state.sortingObject;
          } else if (key === this.state.sortingObject) {
            return data;
          } else {
            return key;
          }
        });
        await onSetHomeownerOnboardingFormData({ keys: sortingData });
        this.setState({ sortingObject: {} });
      }
    }
  };

  onSortingOffers = async (data, index, type) => {
    const {
      homeownerOnboardingFormData,
      onUpdateSuiteOnBoardingOffersOrder,
      onSetHomeownerOnboardingFormData,
    } = this.props;
    if (type === 'start') {
      this.setState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        this.state.sortingObject &&
        this.state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: this.state.sortingObject.id, order: data.order },
            { id: data.id, order: this.state.sortingObject.order },
          ],
          UserId: this.props.user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await onUpdateSuiteOnBoardingOffersOrder(
          params,
          homeownerOnboardingFormData.offers
        );
        this.setState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.offers.map((offer) => {
          if (offer === data) {
            return this.state.sortingObject;
          } else if (offer === this.state.sortingObject) {
            return data;
          } else {
            return offer;
          }
        });
        await onSetHomeownerOnboardingFormData({ offers: sortingData });
        this.setState({ sortingObject: {} });
      }
    }
  };

  handleChecklistDelete = (data) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.checklists.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.checklists.filter(
        (fq) => fq !== data
      );
    }
    onSetHomeownerOnboardingFormData({ checklists: filterData });
  };

  handlekeyDelete = (data) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.keys.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.keys.filter((fq) => fq !== data);
    }
    onSetHomeownerOnboardingFormData({ keys: filterData });
  };

  handleOfferDelete = (data) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.offers.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.offers.filter(
        (fq) => fq !== data
      );
    }
    onSetHomeownerOnboardingFormData({ offers: filterData });
  };

  onAddchecklist = () => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;

    let params = {
      title: this.state.checklistTitle.trim(),
      subTitle: this.state.checklistSubtitle
        ? this.state.checklistSubtitle
        : '',
      subTitleEditor: this.state.checklistSubtitleEditor
        ? this.state.checklistSubtitleEditor
        : '',
    };
    if (
      homeownerOnboardingFormData &&
      homeownerOnboardingFormData.checklists &&
      homeownerOnboardingFormData.checklists.length > 0
    ) {
      let validation = homeownerOnboardingFormData.checklists.filter(
        (key) =>
          key.title.toLowerCase() ===
          this.state.checklistTitle.toLowerCase().trim()
      );
      if (validation && validation.length === 0) {
        onSetHomeownerOnboardingFormData({
          checklists: [...homeownerOnboardingFormData.checklists, params],
        });
        this.setState({
          checklistTitle: '',
          checklistSubtitle: '',
          checklistValidation: '',
          checklistSubtitleEditor: '',
        });
      } else {
        this.setState({
          checklistValidation:
            'You have already created checklist with this title, please use different one.',
        });
      }
    } else {
      onSetHomeownerOnboardingFormData({ checklists: [params] });
      this.setState({
        checklistTitle: '',
        checklistSubtitle: '',
        checklistValidation: '',
        checklistSubtitleEditor: '',
      });
    }
  };

  onAddkeys = () => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let params = {
      name: this.state.name.trim(),
      department: this.state.department ? this.state.department.trim() : '',
      email: this.state.email.trim(),
      phone: this.state.phone,
    };
    if (this.state.email == null || this.state.email == '') {
      onSetHomeownerOnboardingFormData({
        keys: [...homeownerOnboardingFormData.keys, params],
      });
      this.setState({
        name: '',
        department: '',
        email: '',
        emailValidationMessage: '',
        phone: '',
      });
    } else {
      if (validEmailRegex.test(this.state.email.toLowerCase())) {
        if (
          homeownerOnboardingFormData &&
          homeownerOnboardingFormData.keys &&
          homeownerOnboardingFormData.keys.length > 0
        ) {
          let validation = homeownerOnboardingFormData.keys.filter(
            (key) =>
              key.email.toLowerCase() === this.state.email.toLowerCase().trim()
          );
          if (validation && validation.length === 0) {
            onSetHomeownerOnboardingFormData({
              keys: [...homeownerOnboardingFormData.keys, params],
            });
            this.setState({
              name: '',
              department: '',
              email: '',
              emailValidationMessage: '',
              phone: '',
            });
          } else {
            this.setState({
              emailValidationMessage:
                'You have already created key contact with this email, please use different one.',
            });
          }
        } else {
          onSetHomeownerOnboardingFormData({ keys: [params] });
          this.setState({
            name: '',
            department: '',
            email: '',
            emailValidationMessage: '',
            phone: '',
          });
        }
      } else {
        this.setState({
          emailValidationMessage: 'Please enter a valid email address.',
        });
      }
    }
  };

  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      if (selectedImage[i] && selectedImage[i].id) {
        uploadImages.push(selectedImage[i]);
      } else {
        await this.uploadimg(selectedImage[i], (imgData) => {
          uploadImages.push(imgData);
        });
      }
    }
    callback(uploadImages);
  };

  // function to upload the images into aws
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);
    callback(imageUrl);
  };

  isValidURL(string) {
    var res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    return res !== null;
  }

  checkValidation = (data) => {
    let array = [];
    data.map((obj) => {
      if (obj) {
        array = [...array, obj];
      } else {
      }
    });
    return array;
  };

  handleSave = async () => {
    const { homeownerOnboardingFormData, onSaveHomeOwnerOnboarding } =
      this.props;

    let data = this.state;
    let isValidUrl = true;
    var isDuplicateFaq = false;
    var isDuplicateChecklist = false;
    var isDuplicatekey = false;

    var emailKeyValidation = [];
    var faqs = homeownerOnboardingFormData.faqs
      ? homeownerOnboardingFormData.faqs
      : [];
    var checklists = homeownerOnboardingFormData.checklists
      ? homeownerOnboardingFormData.checklists
      : [];
    var keys = homeownerOnboardingFormData.keys
      ? homeownerOnboardingFormData.keys
      : [];
    var offers = homeownerOnboardingFormData.offers
      ? homeownerOnboardingFormData.offers
      : [];
    var faqValidation;
    var checklistValidation;
    var emailValidationMessage;
    var offerValidation;

    var faqData =
      data.faqTitle &&
      data.faqTitle.trim() &&
      data.faqDescription &&
      data.faqDescription.trim();
    var keyData = data.name && data.name.trim();
    var offerData =
      data.offerName &&
      data.offerName.trim() &&
      data.offerLink &&
      data.offerLink.trim() &&
      data.offerLable &&
      data.offerLable.trim() &&
      data.selectedOfferImage.length > 0;

    var faqCheckValidation = this.checkValidation([
      data.faqTitle.trim(),
      data.faqDescription.trim(),
    ]);
    var keyCheckValidation = this.checkValidation([
      data.name.trim(),
      data.department,
      data.email,
      data.phone,
    ]);
    var offerCheckValidation = this.checkValidation([
      data.offerName.trim(),
      data.offerLink.trim() === 'https://' ? '' : data.offerLink.trim(),
      data.offerLable.trim(),
      data.selectedOfferImage.length > 0 ? data.selectedOfferImage[0] : '',
    ]);

    var faqFormChecking = faqData
      ? false
      : faqCheckValidation.length > 0
        ? true
        : false;
    var keysFormChecking = keyData
      ? false
      : keyCheckValidation.length > 0
        ? true
        : false;
    var offerFormChecking = offerData
      ? false
      : offerCheckValidation.length > 0
        ? true
        : false;

    if (faqFormChecking) {
      alert(
        'There is incomplete data in the Faq section, please update it before saving. Thank you.'
      );
    } else if (keysFormChecking) {
      alert(
        'There is incomplete data in the Key contact section, please update it before saving. Thank you.'
      );
    } else if (offerFormChecking) {
      alert(
        'There is incomplete data in the Offers section, please update it before saving. Thank you.'
      );
    } else {
      if (
        data.faqTitle &&
        data.faqTitle.trim() &&
        data.faqDescription &&
        data.faqDescription.trim()
      ) {
        let params = {
          name: this.state.faqTitle.trim(),
          description: this.state.faqDescription.trim(),
        };
        if (faqs && faqs.length > 0) {
          let validation = faqs.filter(
            (key) =>
              key.name.toLowerCase() ===
              this.state.faqTitle.toLowerCase().trim()
          );
          if (validation && validation.length === 0) {
            faqs = [...faqs, params];
            this.setState({
              faqTitle: '',
              faqDescription: '',
              faqValidation: '',
            });
          } else {
            faqValidation =
              'You have already created faq with this question, please use different one.';
            this.setState({
              faqValidation:
                'You have already created faq with this question, please use different one.',
            });
          }
        } else {
          faqs = [params];
          this.setState({
            faqTitle: '',
            faqDescription: '',
            faqValidation: '',
          });
        }
      }
      if (data.checklistTitle && data.checklistTitle.trim()) {
        let params = {
          title: this.state.checklistTitle.trim(),
          subTitle: this.state.checklistSubtitle
            ? this.state.checklistSubtitle
            : '',
          subTitleEditor: this.state.checklistSubtitleEditor
            ? this.state.checklistSubtitleEditor
            : '',
        };
        if (checklists && checklists.length > 0) {
          let validation = checklists.filter(
            (key) =>
              key.title.toLowerCase() ===
              this.state.checklistTitle.toLowerCase().trim()
          );
          if (validation && validation.length === 0) {
            checklists = [...checklists, params];
            this.setState({
              checklistTitle: '',
              checklistSubtitle: '',
              checklistValidation: '',
              checklistSubtitleEditor: '',
            });
          } else {
            checklistValidation =
              'You have already created checklist with this title, please use different one.';
            this.setState({
              checklistValidation:
                'You have already created checklist with this title, please use different one.',
            });
          }
        } else {
          checklists = [params];
          this.setState({
            checklistTitle: '',
            checklistSubtitle: '',
            checklistValidation: '',
            checklistSubtitleEditor: '',
          });
        }
      }
      if (data.name && data.name.trim()) {
        let params = {
          name: this.state.name.trim(),
          department: this.state.department ? this.state.department.trim() : '',
          email: this.state.email.trim(),
          phone: this.state.phone,
        };
        if (this.state.email == null || this.state.email == '') {
          keys = [...keys, params];
          this.setState({
            name: '',
            department: '',
            email: '',
            emailValidationMessage: '',
            phone: '',
          });
        } else {
          if (validEmailRegex.test(this.state.email.toLowerCase())) {
            if (keys && keys.length > 0) {
              let validation = keys.filter(
                (key) =>
                  key.email.toLowerCase() ===
                  this.state.email.toLowerCase().trim()
              );
              if (validation && validation.length === 0) {
                keys = [...keys, params];
                this.setState({
                  name: '',
                  department: '',
                  email: '',
                  emailValidationMessage: '',
                  phone: '',
                });
              } else {
                emailValidationMessage =
                  'You have already created key contact with this email, please use different one.';
                this.setState({
                  emailValidationMessage:
                    'You have already created key contact with this email, please use different one.',
                });
              }
            } else {
              keys = [params];
              this.setState({
                name: '',
                department: '',
                email: '',
                emailValidationMessage: '',
                phone: '',
              });
            }
          } else {
            emailValidationMessage = 'Please enter a valid email address.';
            this.setState({
              emailValidationMessage: 'Please enter a valid email address.',
            });
          }
        }
      }
      if (
        data.offerName &&
        data.offerName.trim() &&
        data.offerLink &&
        data.offerLink.trim() &&
        data.offerLable &&
        data.offerLable.trim() &&
        data.selectedOfferImage.length > 0
      ) {
        var isofferValidUrl = true;
        if (this.state.offerLink) {
          var testCase = this.state.offerLink;
          isofferValidUrl = URLValidation(testCase);
        }
        if (isofferValidUrl === null) {
          offerValidation =
            'You have given invalid link, please provide a valid link.';
        } else {
          let params = {
            name: this.state.offerName.trim(),
            description: this.state.offerDescription,
            descriptionEditor: this.state.offerDescriptionEditor,
            linkName: isofferValidUrl[0],
            linkURL: this.state.offerLable.trim(),
            logo: this.state.selectedOfferImage,
          };

          if (offers && offers.length > 0) {
            let validation = offers.filter(
              (key) =>
                key.name.toLowerCase() ===
                this.state.offerName.toLowerCase().trim()
            );
            if (validation && validation.length === 0) {
              offers = [...offers, params];
              this.setState({
                offerName: '',
                offerDescription: '',
                offerDescriptionEditor: '',
                offerLink: 'https://',
                offerLable: '',
                offerValidation: '',
                selectedOfferImage: [],
              });
            } else {
              offerValidation =
                'You have already created offer with this name, please use different one.';
              this.setState({
                offerValidation:
                  'You have already created offer with this name, please use different one.',
              });
            }
          } else {
            offers = [params];
            this.setState({
              offerName: '',
              offerDescription: '',
              offerLable: '',
              offerLink: 'https://',
              offerValidation: '',
              selectedOfferImage: [],
            });
          }
        }
      }

      if (
        homeownerOnboardingFormData &&
        homeownerOnboardingFormData.videoLink
      ) {
        let testCase = homeownerOnboardingFormData.videoLink;
        isValidUrl = this.isValidURL(testCase);
      }
      if (faqs && faqs.length > 0) {
        var faqArr = faqs.map(function (item) {
          return item.name.toLowerCase();
        });
        isDuplicateFaq = faqArr.some(function (item, idx) {
          return faqArr.indexOf(item) !== idx;
        });
      }
      var filteredChecklists = [];
      if (checklists && checklists.length > 0) {
        filteredChecklists = checklists.map(
          ({ subTitleEditor, ...rest }) => rest
        );

        var checklistArr = filteredChecklists.map(function (item) {
          return item.title.toLowerCase();
        });
        isDuplicateChecklist = checklistArr.some(function (item, idx) {
          return checklistArr.indexOf(item) !== idx;
        });
      }
      if (keys && keys.length > 0) {
        var emailKeyValidation = keys.filter((key) => {
          if (key.email.toLowerCase() !== '') {
            return !validEmailRegex.test(key.email.toLowerCase());
          }
        });
        var keysArr = keys.map(function (item) {
          return item.email.toLowerCase();
        });

        var isDuplicatekey = keysArr.some(function (item, idx) {
          if (item !== '') {
            return keysArr.indexOf(item) != idx;
          }
        });
      }
      let filteredOffers = [];
      if (offers && offers.length > 0) {
        let result = offers.map(({ descriptionEditor, ...rest }) => rest);

        for (var i = 0; i < result.length; i++) {
          let offerObj = result[i];
          if (offerObj && offerObj.logo) {
            if (
              offerObj &&
              offerObj.image &&
              offerObj.image.search(S3BucketConfig.url) !== -1
            ) {
              let imageUrl = offerObj.image;
              filteredOffers = [
                ...filteredOffers,
                { ...offerObj, logo: imageUrl },
              ];
            } else {
              let imageUrl = await upload(offerObj.logo[0]);
              filteredOffers = [
                ...filteredOffers,
                { ...offerObj, logo: imageUrl },
              ];
            }
          } else {
            filteredOffers = [...filteredOffers, { ...offerObj, logo: '' }];
          }
        }
      }

      if (faqValidation) {
        alert(faqValidation);
      } else if (checklistValidation) {
        alert(checklistValidation);
      } else if (emailValidationMessage) {
        alert(emailValidationMessage);
      } else if (offerValidation) {
        alert(offerValidation);
      } else if (isDuplicateFaq) {
        alert('You have added duplicate faq, please validate.');
      } else if (isDuplicateChecklist) {
        alert('You have added duplicate checklist, please validate.');
      } else if (emailKeyValidation && emailKeyValidation.length > 0) {
        alert('Please enter a valid email address.');
      } else if (isDuplicatekey) {
        alert('You have added duplicate key contact, please validate.');
      } else {
        const { occupancyRole } = this.state;
        const params = {
          SuiteOnBoardingTitle: homeownerOnboardingFormData.suiteOnBoardingTitle
            ? homeownerOnboardingFormData.suiteOnBoardingTitle
            : '',
          Title: homeownerOnboardingFormData.title.trim(),
          Video: '',
          VideoType: homeownerOnboardingFormData.videoType,
          Summary: homeownerOnboardingFormData.summary
            ? homeownerOnboardingFormData.summary
            : '',
          PropertyId: homeownerOnboardingFormData.propertyId,
          UserId: this.props.userId,
          SuiteOnBoardingFAQs: faqs,
          SuiteOnBoardingChecklist: filteredChecklists,
          SuiteOnboardingKeyInformation: keys,
          SuiteOnboardingOffers: filteredOffers,
          IsLegalRepresentativeInformation:
            this.state.isLegalRepresentativeInformation === 'yes'
              ? true
              : false,
          IsPostOccupancy: occupancyRole === 'PostOccupancy' ? true : false,
        };

        if (homeownerOnboardingFormData && homeownerOnboardingFormData.id) {
          params.id = homeownerOnboardingFormData.id;
        }
        let imageUrl;
        if (
          homeownerOnboardingFormData &&
          homeownerOnboardingFormData.attachment &&
          homeownerOnboardingFormData.attachment.length > 0
        ) {
          if (homeownerOnboardingFormData.isupload) {
            this.props.startFormLoading();
            imageUrl = await upload(homeownerOnboardingFormData.attachment[0]);
          } else {
            imageUrl = homeownerOnboardingFormData.attachment[0];
          }
          params.Video = imageUrl;
          params.VideoSummary =
            homeownerOnboardingFormData.videoSummary || this.state.videoSummary;
          await onSaveHomeOwnerOnboarding(params);
          this.setState({
            editorState: '',
            summaryText: '',
            videoSummary: '',
            selectedId: null,
          });
          this.clearStateData();
        } else {
          params.Video =
            homeownerOnboardingFormData &&
            homeownerOnboardingFormData.videoLink &&
            homeownerOnboardingFormData.videoLink.trim()
              ? homeownerOnboardingFormData.videoLink.trim()
              : '';
          params.VideoSummary =
            homeownerOnboardingFormData.videoSummary || this.state.videoSummary;
          await onSaveHomeOwnerOnboarding(params);
          this.setState({
            editorState: '',
            summaryText: '',
            videoSummary: '',
            selectedId: null,
          });
          this.clearStateData();
        }
      }
    }
  };

  onDropSequence = (areaData, i) => {
    const { onChangeOrdersSequence, homeownerOnboardingFormData } = this.props;
    let data = {
      SuiteOnBoardingOrder: [
        {
          id: this.state.sequence.id,
          Order: i,
        },
        {
          id: areaData.id,
          Order: this.state.sequence.order,
        },
      ],
      PropertyId: homeownerOnboardingFormData.propertyId,
      UserId: this.props.user.id,
    };
    onChangeOrdersSequence(data);
    this.setState({ sequence: {} });
  };

  onSelectProperty = async (value) => {
    this.props.onClearHomeownerOnboardingFormData();
    await this.props.onFetchHomeOwnerOnboarding(value);
    this.props.onSetHomeownerOnboardingFormData({ propertyId: value });
    this.setState({
      faqTitle: '',
      faqDescription: '',
      checklistTitle: '',
      checklistSubtitle: '',
      name: '',
      department: '',
      email: '',
      phone: '',
      selectedId: null,
      faqValidation: '',
      emailValidationMessage: '',
      checklistValidation: '',
      sequence: {},
      summaryText: '',
      editorState: '',
      videoSummary: '',
      offerValidation: '',
      offerName: '',
      offerDescription: '',
      offerDescriptionEditor: '',
      checklistSubtitleEditor: '',
      offerLink: 'https://',
      offerLable: '',
      selectedOfferImage: [],
    });
  };

  onAddOffer = () => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    var isValidUrl = true;
    if (this.state.offerLink) {
      var testCase = this.state.offerLink;
      isValidUrl = URLValidation(testCase);
    }
    if (isValidUrl === null) {
      alert('You have given invalid link, please provide a valid link.');
    } else {
      let params = {
        name: this.state.offerName.trim(),
        description: this.state.offerDescription,
        descriptionEditor: this.state.offerDescriptionEditor,
        linkName: isValidUrl[0],
        linkURL: this.state.offerLable.trim(),
        logo: this.state.selectedOfferImage,
      };

      if (
        homeownerOnboardingFormData &&
        homeownerOnboardingFormData.offers &&
        homeownerOnboardingFormData.offers.length > 0
      ) {
        let validation = homeownerOnboardingFormData.offers.filter(
          (key) =>
            key.name.toLowerCase() === this.state.offerName.toLowerCase().trim()
        );
        if (validation && validation.length === 0) {
          onSetHomeownerOnboardingFormData({
            offers: [...homeownerOnboardingFormData.offers, params],
          });
          this.setState({
            offerName: '',
            offerDescription: '',
            offerDescriptionEditor: '',
            offerLink: 'https://',
            offerLable: '',
            offerValidation: '',
            selectedOfferImage: [],
          });
        } else {
          this.setState({
            offerValidation:
              'You have already created offer with this name, please use different one.',
          });
        }
      } else {
        onSetHomeownerOnboardingFormData({ offers: [params] });
        this.setState({
          offerName: '',
          offerDescription: '',
          offerLable: '',
          offerLink: 'https://',
          offerValidation: '',
          selectedOfferImage: [],
        });
      }
    }
  };

  onSetEditOffer = (value, type, index) => {
    const { onSetHomeownerOnboardingFormData, homeownerOnboardingFormData } =
      this.props;
    let filterData = homeownerOnboardingFormData.offers.map((cl, i) => {
      if (i === index) {
        if (type === 'description') {
          return { ...cl, [type]: value, descriptionEditor: value };
        } else {
          if (type === 'logo' && cl && cl.image) {
            return { ...cl, [type]: value, image: null };
          } else {
            return { ...cl, [type]: value };
          }
        }
      } else {
        return cl;
      }
    });
    onSetHomeownerOnboardingFormData({ offers: filterData });
  };

  handleNumKeys = (event) => {
    if (
      (event.charCode > 31 && event.charCode < 48) ||
      (event.charCode > 57 && event.charCode < 127)
    ) {
      event.preventDefault();
    }
  };

  onClearFormData = (type) => {
    if (type === 'faq') {
      this.setState({ faqTitle: '', faqDescription: '', faqValidation: '' });
    } else if (type === 'checklist') {
      this.setState({
        checklistTitle: '',
        checklistSubtitle: '',
        checklistValidation: '',
        checklistSubtitleEditor: '',
      });
    } else if (type === 'key') {
      this.setState({
        name: '',
        department: '',
        email: '',
        emailValidationMessage: '',
        phone: '',
      });
    } else {
      this.setState({
        offerName: '',
        offerDescription: '',
        offerDescriptionEditor: '',
        offerLink: 'https://',
        offerLable: '',
        offerValidation: '',
        selectedOfferImage: [],
      });
    }
  };
  onDeleteOrder = async (orderId) => {
    const { onDeleteOrder, user } = this.props;
    await onDeleteOrder(orderId, user.id);
    this.onClearData();
  };
  render() {
    const {
      loader,
      prLoader,
      properties,
      onSetHomeownerOnboardingFormData,
      homeownerOnboardingFormData,
      homeownerOnboarding,
    } = this.props;
    let validation =
      homeownerOnboardingFormData.propertyId &&
      homeownerOnboardingFormData.title &&
      homeownerOnboardingFormData.title.trim();
    const { occupancyRole } = this.state;
    return (
      <div className="header_section">
        <div className="header_box">
          <div className="configure_heading">
            <h2 style={{ marginBottom: 0 }}>Home Owner Onboarding</h2>
          </div>
          <div
            class="next_btn text-right"
            style={{ pointerEvents: !validation && 'none', cursor: 'pointer' }}
            onClick={() => this.handleSave()}
          >
            <a>Save</a>
          </div>
        </div>

        <Row>
          {loader || prLoader || this.state.loading ? (
            <Loader center={true} />
          ) : null}
          <Col md={8} xs={12}>
            <div>
              <div className="select-dropdown">
                <Select
                  value={
                    homeownerOnboardingFormData &&
                    homeownerOnboardingFormData.propertyId
                      ? homeownerOnboardingFormData.propertyId
                      : ''
                  }
                  onChange={(e) => {
                    onSetHomeownerOnboardingFormData({
                      propertyId: e.target.value,
                    });
                    this.onSelectProperty(e.target.value);
                  }}
                  options={properties.map((pty) => ({
                    value: pty.id,
                    label: `${pty.name}`,
                  }))}
                  placeholder="Select Property"
                  block
                />
              </div>
              <div class="homeOwnercard">
                <div class="input_box">
                  <div class="homeOwnerinput_section homeOwnerinputContainer">
                    <div class="mt-10 onboardingTitleInputLable xs-12">
                      <div className="input__require">
                        <label className="input__label">
                          Onboarding title:
                        </label>
                      </div>
                    </div>

                    <div class="onboardingTitleInputForm xs-12">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Add a Title"
                        aria-label="default input example"
                        value={
                          homeownerOnboardingFormData.suiteOnBoardingTitle
                            ? homeownerOnboardingFormData.suiteOnBoardingTitle
                            : ''
                        }
                        onChange={(e) =>
                          onSetHomeownerOnboardingFormData({
                            suiteOnBoardingTitle: e.target.value,
                          })
                        }
                        maxLength={30}
                      />
                    </div>
                  </div>

                  <div class="homeOwnerinput_section homeOwnerinputContainer">
                    <div class="mt-10 inputLable">
                      <div className="input__require">
                        <label className="input__label">Title:</label>
                        <div className="input__required" />
                      </div>
                    </div>

                    <div class="inputForm">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Add a Title"
                        aria-label="default input example"
                        value={
                          homeownerOnboardingFormData.title
                            ? homeownerOnboardingFormData.title
                            : ''
                        }
                        onChange={(e) =>
                          onSetHomeownerOnboardingFormData({
                            title: e.target.value,
                          })
                        }
                        required
                        disabled={!homeownerOnboardingFormData?.propertyId}
                      />
                    </div>
                  </div>
                  <div class="homeOwnerinput_section homeOwnerinputContainer">
                    <div class="mt-10 inputLable">
                      <div className="input__require">
                        <label className="input__label">Video:</label>
                      </div>
                    </div>

                    <div class="inputForm">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Add a Link"
                        aria-label="default input example"
                        value={
                          homeownerOnboardingFormData.videoLink
                            ? homeownerOnboardingFormData.videoLink
                            : ''
                        }
                        onChange={(e) =>
                          onSetHomeownerOnboardingFormData({
                            videoLink: e.target.value,
                            videoType: 'Link',
                          })
                        }
                        required
                      />
                    </div>
                  </div>
                  <div class="orWidth">
                    <p>or</p>
                  </div>
                  <div
                    class="homeOwnerinput_section homeOwnerinputContainer"
                    style={{ width: '100%', marginLeft: '12px' }}
                  >
                    <div class="mt-10 inputLable"> </div>
                    <div class="inputForm">
                      <File
                        label=""
                        type={['video', 'image']}
                        onSelect={(file) => this.selectMultipleItems(file)}
                        files={[]}
                        multiSelect={false}
                      />
                    </div>
                  </div>
                  <div
                    className="input homeOwnerinput_section homeOwnerinputContainer"
                    style={{ width: '100%', marginLeft: '12px' }}
                  >
                    <div class="mt-10 inputLable"> </div>
                    <div class="inputForm">
                      {homeownerOnboardingFormData.attachment?.length > 0
                        ? homeownerOnboardingFormData.attachment.map(
                            (data, i) => (
                              <div
                                style={{
                                  marginRight: 40,
                                  marginTop: -20,
                                  marginBottom: 10,
                                }}
                              >
                                <Row granola>
                                  <Col granola xs="12" md="11">
                                    <div style={{ wordBreak: 'break-all' }}>
                                      {data && data.path
                                        ? data.path
                                        : data.split('.com/')[1]}
                                    </div>
                                  </Col>
                                  <Col granola xs="12" md="1">
                                    <div
                                      className="videoText"
                                      onClick={() => this.handleDelete(data, i)}
                                    >
                                      <FontAwesomeIcon
                                        glyph="times-circle"
                                        weight="light"
                                        size="small"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            )
                          )
                        : null}
                    </div>
                  </div>

                  <div
                    className="input homeOwnerinput_section homeOwnerinputContainer"
                    style={{ width: '100%', marginLeft: '12px' }}
                  >
                    <div class="mt-10 inputLable">Summary: </div>
                    <div class="inputForm">
                      <div
                        class
                        style={{
                          border: '0.1rem solid rgba(83, 83, 83, 0.25)',
                          borderRadius: '5px',
                          padding: '0px',
                        }}
                        className="input__control"
                      >
                        <TextEditor
                          editorState={this.state.videoSummary}
                          placeholder="Summary"
                          onEditorStateChange={this.onEditorChange1}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="input homeOwnerinput_section homeOwnerinputContainer"
                    style={{ marginLeft: '12px', marginTop: '25px' }}
                  >
                    <Checkbox
                      value={occupancyRole === 'PostOccupancy' ? false : true}
                      label="Display for pre-occupancy"
                      onChange={() =>
                        this.setState({ occupancyRole: 'PreOccupancy' })
                      }
                    />
                  </div>
                  <div
                    className="input homeOwnerinput_section homeOwnerinputContainer"
                    style={{ marginLeft: '12px', marginTop: '25px' }}
                  >
                    <Checkbox
                      value={occupancyRole === 'PostOccupancy' ? true : false}
                      label="Display for post occupancy"
                      onChange={() =>
                        this.setState({ occupancyRole: 'PostOccupancy' })
                      }
                    />
                  </div>

                  {/* <div className="input homeOwnerinput_section homeOwnerinputContainer" style={{width:'100%', marginLeft:'12px', marginTop:'25px'}}>
                  <div class='mt-10 inputLable'>
                  <div className="input__require">

                      <label className="input__label">Summary:</label>
                      <div className="input__required" />
                    </div>
                    </div>
                      <div class='inputForm'>
                 <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius:'5px', padding:'0px' }} className="input__control">

                  <TextEditor
                      editorState={this.state.editorState}
                      onEditorStateChange={this.onEditorChange}
                  />
                      </div>

                    </div>

                  </div> */}
                  <div
                    className="input homeOwnerinput_section homeOwnerinputContainer"
                    style={{ marginLeft: '12px', marginTop: '25px' }}
                  >
                    Do you want the Homeowner to add legal representation form
                    ?&nbsp;&nbsp;&nbsp;
                    <span
                      onClick={() =>
                        this.setState({
                          isLegalRepresentativeInformation: 'yes',
                        })
                      }
                      style={
                        this.state.isLegalRepresentativeInformation == 'yes'
                          ? {
                              backgroundColor: Colors.toggleAndButtonColor,
                              width: '10%',
                              height: '25px',
                              textAlign: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              color: 'white',
                              lineHeight: '25px',
                              borderTopLeftRadius: '5px',
                              borderBottomLeftRadius: '5px',
                              cursor: 'pointer',
                            }
                          : {
                              backgroundColor: '#F2F2F2',
                              width: '10%',
                              height: '25px',
                              textAlign: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              lineHeight: '25px',
                              borderTopLeftRadius: '5px',
                              borderBottomLeftRadius: '5px',
                              color: '#36396D',
                              cursor: 'pointer',
                            }
                      }
                    >
                      Yes
                    </span>
                    <span
                      onClick={() =>
                        this.setState({
                          isLegalRepresentativeInformation: 'no',
                        })
                      }
                      style={
                        this.state.isLegalRepresentativeInformation == 'no'
                          ? {
                              backgroundColor: Colors.toggleAndButtonColor,
                              width: '10%',
                              height: '25px',
                              textAlign: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              color: 'white',
                              lineHeight: '25px',
                              borderTopRightRadius: '5px',
                              borderBottomRightRadius: '5px',
                              cursor: 'pointer',
                            }
                          : {
                              backgroundColor: '#F2F2F2',
                              width: '10%',
                              height: '25px',
                              textAlign: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              lineHeight: '25px',
                              borderTopRightRadius: '5px',
                              borderBottomRightRadius: '5px',
                              color: '#36396D',
                              cursor: 'pointer',
                            }
                      }
                    >
                      No
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} xs={12}>
            <OnboardingOrders
              homeownerOnboarding={homeownerOnboarding}
              onClearData={this.onClearData}
              selectedId={this.state.selectedId}
              isEnableReorder={this.state.isEnableReorder}
              onReorder={this.onReorder}
              fetchOrderData={(area) => {
                this.setState({ loading: true });
                this.fetchOrderData(area);
                this.setState({
                  selectedId: this.state.isEnableReorder ? null : area.id,
                });
              }}
              onDropSequence={(area, i) => this.onDropSequence(area, i)}
              onDeleteOrder={this.onDeleteOrder}
              onDragStart={(area) =>
                this.setState({
                  sequence: this.state.isEnableReorder ? area : {},
                })
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} xs={12}>
            <div className="homeOwnerTabs">
              <Tabs
                items={[
                  {
                    label: 'FAQ',
                    content: (
                      <AddFaqComponent
                        faqs={
                          homeownerOnboardingFormData &&
                          homeownerOnboardingFormData.faqs
                            ? homeownerOnboardingFormData.faqs
                            : []
                        }
                        onSetFaq={this.onSetFaq}
                        onSetEditFaq={this.onSetEditFaq}
                        data={this.state}
                        onAddFaq={this.onAddFaq}
                        handleFaqDelete={this.handleFaqDelete}
                        onSortingFAQ={this.onSortingFAQ}
                        orderId={
                          homeownerOnboardingFormData.id
                            ? homeownerOnboardingFormData.id
                            : ''
                        }
                        onClearFormData={this.onClearFormData}
                      />
                    ),
                  },
                  {
                    label: 'CHECKLIST',
                    content: (
                      <AddChecklistComponent
                        checklists={
                          homeownerOnboardingFormData &&
                          homeownerOnboardingFormData.checklists
                            ? homeownerOnboardingFormData.checklists
                            : []
                        }
                        onSetFaq={this.onSetchecklist}
                        onSetEditFaq={this.onSetEditchecklists}
                        data={this.state}
                        onAddFaq={this.onAddchecklist}
                        handleChecklistDelete={this.handleChecklistDelete}
                        onSortingChecklist={this.onSortingChecklist}
                        onEditorFaqChange={this.onEditorFaqChange}
                        orderId={
                          homeownerOnboardingFormData.id
                            ? homeownerOnboardingFormData.id
                            : ''
                        }
                        onClearFormData={this.onClearFormData}
                      />
                    ),
                  },
                  {
                    label: 'KEY CONTACT',
                    content: (
                      <AddKeyInformation
                        keys={
                          homeownerOnboardingFormData &&
                          homeownerOnboardingFormData.keys
                            ? homeownerOnboardingFormData.keys
                            : []
                        }
                        onSetKey={this.onSetchecklist}
                        onSetEditKey={this.onSetEditkeys}
                        data={this.state}
                        onAddKey={this.onAddkeys}
                        handleKeyPress={this.handleNumKeys}
                        handlekeyDelete={this.handlekeyDelete}
                        onSortingKey={this.onSortingKey}
                        orderId={
                          homeownerOnboardingFormData.id
                            ? homeownerOnboardingFormData.id
                            : ''
                        }
                        onClearFormData={this.onClearFormData}
                      />
                    ),
                  },
                  {
                    label: 'OFFERS',
                    content: (
                      <AddOffers
                        offers={
                          homeownerOnboardingFormData &&
                          homeownerOnboardingFormData.offers
                            ? homeownerOnboardingFormData.offers
                            : []
                        }
                        onSetOffer={this.onSetchecklist}
                        onSetEditOffer={this.onSetEditOffer}
                        data={this.state}
                        onAddOffer={this.onAddOffer}
                        handleOfferDelete={this.handleOfferDelete}
                        onEditorOfferChange={this.onEditorOfferChange}
                        selectImage={this.selectOfferImage}
                        onSortingOffers={this.onSortingOffers}
                        orderId={
                          homeownerOnboardingFormData.id
                            ? homeownerOnboardingFormData.id
                            : ''
                        }
                        onClearFormData={this.onClearFormData}
                      />
                    ),
                  },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
  properties: selectProperties(state),
  homeownerOnboardingFormData: selectHomeownerOnboardingFormData(state),
  homeownerOnboarding: selectHomeownerOnboarding(state),
  loader: selectFormLoader(state),
  prLoader: selectPRLoader(state),
});
const maptDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchProperties: fetchProperties,
      onSetHomeownerOnboardingFormData: setHomeownerOnboardingFormData,
      startFormLoading: startFormLoading,
      onSaveHomeOwnerOnboarding: saveHomeOwnerOnboarding,
      onFetchHomeOwnerOnboarding: fetchHomeOwnerOnboarding,
      onChangeOrdersSequence: changeOrdersSequence,
      onClearHomeownerOnboardingFormData: clearsetHomeownerOnboardingFormData,
      clearHomeOwnerOnboarding: clearHomeOwnerOnboarding,
      onUpdateSuiteOnBoardingFAQsOrder: onUpdateSuiteOnBoardingFAQsOrder,
      onUpdateSuiteOnBoardingChecklistsOrder:
        onUpdateSuiteOnBoardingChecklistsOrder,
      onUpdateSuiteOnBoardingKeysOrder: onUpdateSuiteOnBoardingKeysOrder,
      onUpdateSuiteOnBoardingOffersOrder: onUpdateSuiteOnBoardingOffersOrder,
      onDeleteOrder: onDeleteOrder,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  maptDispatchToProps
)(HomeownerOnboardingComponent);
